import { QuestionCircle } from 'components/common/Icons';

export const Help: React.FunctionComponent<{ onClick: () => void, title?: string }> = ({ onClick, title="Help" }) => {
  return (
    <div title={title} className="d-flex justify-content-center align-items-center">
      <div role="button" onClick={() => onClick()}><QuestionCircle/></div>
    </div>
  );
}